<div class="container">
    <div  class="container-inventory">

        <div class="header">
        <h1 class="title">{{ 'NEW_COLLECTION' | translate }}</h1>
        <app-back-arrow-settings [callback]="setListingCollections"></app-back-arrow-settings>
        </div>
    <form #myForm="ngForm">
      <div class="form-card">
        <label class="form-label is-required" for="collection_name">{{'NAME' | translate}}</label>
        <input type="text" class="form-control" id="collectionName" placeholder="{{'COLLECTION_NAME' | translate}}"
        (keyup)="ChangeCollectionName($event)" value="{{collection.name}}" #collectionName/>

        <label class="form-label" for="collection_description">{{'DESCRIPTION' | translate}}</label>
        <textarea class="form-control" id="collectionDescription" placeholder="{{ 'COLLECTION_DESCRIPTION' | translate }}"
          (keyup)="ChangeCollectionDescription($event)" #collectionDescription>{{collection.description}}
        </textarea>
        <div class=" logged-user-switch">
          <label class="form-label">{{'ONLY_VERIFIED' | translate}}</label>
          <mat-slide-toggle [(ngModel)]="collection.isForVerifiedClient" class="switch" name="first"></mat-slide-toggle>
        </div>
        <div class="form-buttons">
            <button type="button" class="btn btn-outline-secondary submit-btn" (click)="validateFormData()">
              {{"CREATE" | translate}}
            </button>
          </div>
      </div>
    </form>
    </div>
</div>

<div class="modal collection-confirm-modal" id="collectionLoadingModal" tabindex="-1">
  <div class="modal-dialog collection-modal-dialog" role="document">
    <div class="modal-content collection-modal-content">
      <div class="modal-body collection-modal-body">
        <div class="loading">
          <div class="spinner-border" role="status"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal collection-confirm-modal" id="successCollectionsModal" tabindex="-1">
  <div class="modal-dialog collection-modal-dialog" role="document">
    <div class="modal-content collection-modal-content">
      <div class="modal-body collection-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{ 'COLLECTION_CREATED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="requiredCollectionModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}!</h3>
        <p class="text-center">{{ 'COLLECTION_NAME_REQUIRED' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal collection-confirm-modal fade" id="errorCollectionsModal" tabindex="-1">
  <div class="modal-dialog collection-modal-dialog" role="document">
    <div class="modal-content collection-modal-content">
      <div class="modal-body collection-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
